<div [formGroup]="form" *ngIf="form">
  <div class="flex mt-3">
    <mat-slide-toggle color="primary" formControlName="enableWaitingTimeCharges"></mat-slide-toggle>
    <div class="ml-2">
      <p class="small text-900 m-0 mb-2">{{ 'sharedFeatures.EnableWaitingTimeChargesPolicy' | translate }}</p>
      <p class="small text-400 m-0">{{ 'sharedFeatures.EnableWaitingTimeChargesPolicyDesc' | translate }}</p>
    </div>
  </div>

  <app-row class="mt-3 pl-6" *ngIf="form.get('enableWaitingTimeCharges')?.value">
    <app-col cols="6" md="3">
      <mat-label class="d-block small text-400 asterisk-after">
        {{ 'sharedFeatures.FreeWaitingTime' | translate }}
        <app-icon
          class="d-inline-block align-middle"
          size="xs"
          name="bold-message-question"
          [matTooltip]="'sharedFeatures.FreeWaitingTimeTooltip' | translate"
          matTooltipPosition="above"
        ></app-icon>
      </mat-label>
      <mat-form-field appearance="outline">
        <input matInput type="number" formControlName="freeWaitingTime" />
        <span matSuffix class="small text-300 weight-semi-bold">{{ 'sharedFeatures.Hour' | translate }}</span>
        <mat-error *ngIf="form.get('freeWaitingTime')?.hasError('required')">{{ 'ErrorMessages.Required' | translate }}</mat-error>
        <mat-error *ngIf="form.get('freeWaitingTime')?.hasError('min')">{{ 'ErrorMessages.MinimumValue' | translate: { value: 0 } }}</mat-error>
      </mat-form-field>
    </app-col>

    <app-col cols="6" md="3">
      <mat-label class="d-block small text-400">
        {{ 'sharedFeatures.HourlyRate' | translate }}
        <app-icon
          class="d-inline-block align-middle"
          size="xs"
          name="bold-message-question"
          [matTooltip]="'sharedFeatures.HourlyRateTooltip' | translate"
          matTooltipPosition="above"
        ></app-icon>
      </mat-label>
      <mat-form-field appearance="outline">
        <input matInput type="number" formControlName="hourlyRate" />
        <span riyalCurrency matSuffix class="text-300"></span>
      </mat-form-field>
    </app-col>

    <app-col cols="6" md="3">
      <mat-label class="d-block small text-400">
        {{ 'sharedFeatures.MaximumWaitingHours' | translate }}
        <app-icon
          class="d-inline-block align-middle"
          size="xs"
          name="bold-message-question"
          [matTooltip]="'sharedFeatures.MaximumWaitingHoursTooltip' | translate"
          matTooltipPosition="above"
        ></app-icon>
      </mat-label>
      <mat-form-field appearance="outline">
        <input matInput type="number" formControlName="maximumWaitingHours" />
        <span matSuffix class="small text-300 weight-semi-bold">{{ 'sharedFeatures.Hour' | translate }}</span>
      </mat-form-field>
    </app-col>

    <app-col cols="6" md="3">
      <mat-label class="d-block small text-400 asterisk-after">
        {{ 'sharedFeatures.DailyRate' | translate }}
        <app-icon
          class="d-inline-block align-middle"
          size="xs"
          name="bold-message-question"
          [matTooltip]="'sharedFeatures.DailyRateTooltip' | translate"
          matTooltipPosition="above"
        ></app-icon>
      </mat-label>
      <mat-form-field appearance="outline">
        <input matInput type="number" formControlName="dailyRate" />
        <span riyalCurrency matSuffix class="text-300"></span>
        <mat-error *ngIf="form.get('dailyRate')?.hasError('required')">{{ 'ErrorMessages.Required' | translate }}</mat-error>
        <mat-error *ngIf="form.get('dailyRate')?.hasError('min')">{{ 'ErrorMessages.MinimumValue' | translate: { value: 0.01 } }}</mat-error>
      </mat-form-field>
    </app-col>
  </app-row>

  <div class="col-md-2 ml-auto mt-3">
    <button
      mat-raised-button
      class="btn-primary btn form-control-full-width"
      (click)="save()"
    >
      {{ "shared.Buttons.Save" | translate }}
    </button>
  </div>
</div>
